import SocialEmbed from './social-embed'
import SocialQuery from './social-embed.query'

export { SocialQuery }

export default SocialEmbed
